import { useNavigate } from "react-router-dom";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Space, Typography } from "antd";

import { getUser } from "../../../services/auth";
import useDeviceType from "../../../utils/deviceType";
import { ClaimTable } from "../components/ClaimTable";

const ClaimManagement = () => {
  const { Title } = Typography;
  const navigate = useNavigate();
  const { isMobile } = useDeviceType();
  const user = getUser();
  const role = user.role;

  return (
    <div style={{ paddingInline: 20 }}>
      {isMobile ? (
        <Space direction="vertical" style={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <Title level={3} style={{ marginBottom: 10 }}>
              Claim Listing
            </Title>
          </div>
          {(role === "staff" || role === "lawyer") && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Button
                type="primary"
                style={{ marginBottom: "1rem" }}
                onClick={() => navigate("/claims/new")}
              >
                <PlusOutlined />
                Apply Claim
              </Button>
            </div>
          )}
        </Space>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "nowrap",
          }}
        >
          <Title level={3} style={{ marginBottom: "1em" }}>
            Claim Listing
          </Title>
          {(role === "staff" || role === "lawyer") && (
            <Button
              type="primary"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 0,
              }}
              onClick={() => navigate("/claims/new")}
            >
              <PlusOutlined />
              Apply Claim
            </Button>
          )}
        </div>
      )}
      <ClaimTable />
    </div>
  );
};

export default ClaimManagement;
